import { render, staticRenderFns } from "./TopStatsContainer.vue?vue&type=template&id=fc4e051e&scoped=true&"
import script from "./TopStatsContainer.vue?vue&type=script&lang=js&"
export * from "./TopStatsContainer.vue?vue&type=script&lang=js&"
import style0 from "./TopStatsContainer.vue?vue&type=style&index=0&id=fc4e051e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4e051e",
  null
  
)

export default component.exports